import { getAuthHeaders } from "../utils/auth";

export interface AnalyticsSummary {
  totalPackagesOrdered: number;
  totalIncome: number;
  totalPaidOrders: number;
  averageOrderValue: number;
  pendingOrders: number;
  completedOrders: number;
  recentOrdersCount: number;
}

export interface RevenueByPackage {
  packageId: string;
  packageName: string;
  revenue: number;
  orderCount: number;
}

export interface OrdersByStatus {
  status: string;
  count: number;
}

export interface OrdersByCampus {
  campusId: string;
  campusName: string;
  count: number;
}

export interface RecentOrder {
  id: string;
  status: string;
  amount: number;
  createdAt: Date;
  packageId: string;
  campusId: string;
}

export interface AnalyticsData {
  summary: AnalyticsSummary;
  revenueByPackage: RevenueByPackage[];
  ordersByStatus: OrdersByStatus[];
  ordersByCampus: OrdersByCampus[];
  recentOrders: RecentOrder[];
}

/**
 * Get analytics data (admin only)
 */
export const getAnalytics = async (): Promise<AnalyticsData> => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`/api/analytics`, {
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const analyticsData: AnalyticsData = await response.json();
    return analyticsData;
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
};
